<template>
<el-tabs class="tab-button" v-model="activeTabName" @tab-click="changeActiveTab">
  <!-- 무선 AP -->
  <el-tab-pane :label="tabs.ap.label" :name="tabs.ap.name" :key="tabs.ap.name">
    <w-wireless-ap-table :ref="tabs.ap.name" :operation-flag="operationFlag" :active="tabs.ap.active" />
  </el-tab-pane>
  <!-- 인터페이스 -->
  <el-tab-pane :label="tabs.interface.label" :name="tabs.interface.name" :key="tabs.interface.name">
    <w-interface-table :ref="tabs.interface.name" :operation-flag="operationFlag" :active="tabs.interface.active" />
  </el-tab-pane>
  <!-- Config 변경  -->
  <el-tab-pane v-if="!operationFlag" :label="tabs.config.label" :name="tabs.config.name" :key="tabs.config.name">
    <w-config-change-info :ref="tabs.config.name" :active="tabs.config.active" />
  </el-tab-pane>
  <!-- 하드웨어 상태 -->
  <el-tab-pane :label="tabs.hardware.label" :name="tabs.hardware.name" :key="tabs.hardware.name">
    <w-hardware-table :ref="tabs.hardware.name" :operation-flag="operationFlag" :active="tabs.hardware.active" />
  </el-tab-pane>
  <!-- 라우팅 -->
  <el-tab-pane v-if="!operationFlag" :label="tabs.routing.label" :name="tabs.routing.name" :key="tabs.routing.name">
    <w-routing-info-table :ref="tabs.routing.name" :active="tabs.routing.active" />
  </el-tab-pane>
  <!-- 연결 장비 -->
  <el-tab-pane v-if="!operationFlag" :label="tabs.connectDevice.label" :name="tabs.connectDevice.name" :key="tabs.connectDevice.name">
    <w-connection-device-table :ref="tabs.connectDevice.name" :active="tabs.connectDevice.active" />
  </el-tab-pane>
  <!-- TCP 정보  -->
  <el-tab-pane :label="tabs.tcp.label" :name="tabs.tcp.name" :key="tabs.tcp.name">
    <w-tcp-info-table :ref="tabs.tcp.name" :operation-flag="operationFlag" :active="tabs.tcp.active" />
  </el-tab-pane>
  <!-- 프로세스 -->
  <el-tab-pane :label="tabs.process.label" :name="tabs.process.name" :key="tabs.process.name" v-if="isShowProcess">
    <w-process-table :ref="tabs.process.name" :operation-flag="operationFlag" :active="tabs.process.active" />
  </el-tab-pane>
  <!-- 시스템 로그  -->
  <el-tab-pane :label="tabs.syslog.label" :name="tabs.syslog.name" :key="tabs.syslog.name">
    <w-syslog-table :ref="tabs.syslog.name" :operation-flag="operationFlag" :active="tabs.syslog.active && active" />
  </el-tab-pane>
  <!-- SNMP 트랩 -->
  <el-tab-pane :label="tabs.trap.label" :name="tabs.trap.name" :key="tabs.trap.name">
    <w-snmp-trap-table :ref="tabs.trap.name" :operation-flag="operationFlag" :active="tabs.trap.active && active" />
  </el-tab-pane>
</el-tabs>
</template>

<script>
import isNil from 'lodash/isNil';
import { mapGetters } from 'vuex';
import WInterfaceTable from '@/views/performance/node/analysis/netdevice/components/table/InterfaceTable';
import WSyslogTable from '@/views/performance/node/analysis/netdevice/components/table/SyslogTable';
import WConfigChangeInfo from '@/views/performance/node/analysis/netdevice/components/table/ConfigChangeInfo';
import WHardwareTable from '@/views/performance/node/analysis/netdevice/components/table/HardwareTable';
import WRoutingInfoTable from '@/views/performance/node/analysis/netdevice/components/table/RoutingInfoTable';
import WConnectionDeviceTable from '@/views/performance/node/analysis/netdevice/components/table/ConnectionDeviceTable';
import WTcpInfoTable from '@/views/performance/node/analysis/netdevice/components/table/TcpInfoTable';
import WProcessTable from '@/views/performance/node/analysis/netdevice/components/table/ProcessTable';
import WSnmpTrapTable from '@/views/performance/node/analysis/netdevice/components/table/SnmpTrapTable';
import WWirelessApTable from './components/table/WirelessApTable';

export default {
  name: 'WPerformanceApControllerAnalysisTable',
  components: {
    WInterfaceTable,
    WSyslogTable,
    WConfigChangeInfo,
    WHardwareTable,
    WRoutingInfoTable,
    WConnectionDeviceTable,
    WTcpInfoTable,
    WProcessTable,
    WWirelessApTable,
    WSnmpTrapTable,
  },
  props: {
    operationFlag: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
    },
  },
  data() {
    return {
      activeTabName: '',
      activeTab: null,
      tabs: {
        ap: {
          name: 'ap',
          label: '무선 AP',
          active: false,
        },
        interface: {
          name: 'interface',
          label: '인터페이스',
          active: false,
        },
        config: {
          name: 'config',
          label: '컨피그 변경',
          active: false,
        },
        hardware: {
          name: 'hardware',
          label: '하드웨어 정보',
          active: false,
        },
        routing: {
          name: 'routing',
          label: '라우팅 정보',
          active: false,
        },
        l4Session: {
          name: 'l4Session',
          label: 'L4 세션',
          active: false,
        },
        connectDevice: {
          name: 'connectDevice',
          label: '연결 장비',
          active: false,
        },
        tcp: {
          name: 'tcp',
          label: 'TCP 정보',
          active: false,
        },
        process: {
          name: 'process',
          label: '프로세스',
          active: false,
        },
        syslog: {
          name: 'syslog',
          label: '시스템 로그',
          active: false,
        },
        trap: {
          name: 'trap',
          label: 'SNMP 트랩',
          active: false,
        },
      },
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
    /**
     * 프로세스 탭 제공 여부
     * [현재 제공 벤더]
     * cisco: 9 / extreme: 1916 / H3C: 25506 / Juniper: 2636
     * @author Ju
     * @return {Boolean} [description]
     */
    isShowProcess() {
      const provideProcessVendor = [9, 1916, 25506, 2636];
      return provideProcessVendor.indexOf(this.selectedNode.obj.objCompanyId) >= 0;
    },
  },
  watch: {
    selectedNode: {
      handler() {
        if (!this.isShowProcess && this.activeTabName === this.tabs.process.name) {
          this.activeTabName = this.tabs.ap.name;
          this.changeActiveTab();
        } else if (this.operationFlag && this.active) {
          this.$nextTick(() => {
            this.$refs[this.activeTabName].loadData();
          });
        }
      },
    },
    active: {
      handler(flag) {
        // [운영 탭] 기존 분석탭은 차트에서 loadData 하는 구조였기에 운영탭에서는 아래와 같이 ref를 이용하여 직접 loadData한다.
        if (flag && this.operationFlag) {
          this.$nextTick(() => {
            this.$refs[this.activeTab.name].loadData();
          });
        }
      },
    },
  },
  mounted() {
    this.activeTabName = this.tabs.ap.name;
    this.changeActiveTab();
  },
  methods: {
    changeActiveTab() {
      // console.debug(this.tabs, this.activeTabName);
      const activeTab = this.tabs[this.activeTabName];
      activeTab.active = true;
      if (!isNil(this.activeTab)) {
        this.activeTab.active = false;
      }
      this.activeTab = activeTab;

      // 운영 탭에서 하위 탭들 loadData 수행
      if (this.operationFlag && this.active) {
        this.$nextTick(() => {
          this.$refs[activeTab.name].loadData();
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/ap-controller/PerformanceApControllerAnalysisTable.vue